export default "__VITE_ASSET__3HTNyIwt__"